import { walletIconBase64, downArrowBase64, walletIconDarkBase64, downArrowDarkBase64 } from './iconsBase64';
import styleRender from './style';
import htmlRender from './html';
import type Draggabilly from 'draggabilly';
import { UIMode } from '../../types';
import { Auth } from '../../auth';
import { walletUrl } from '../../utils/wallet-url';
import qs from 'qs';
import { isBraveBrowser, isNullish, isParticleDev } from '../../utils';

export enum WalletEntryPosition {
    BR = 'bottom-right',
    BL = 'bottom-left',
    TR = 'top-right',
    TL = 'top-left',
}

export interface WalletEntryOptions {
    position?: WalletEntryPosition;
    preload?: boolean;
}

let timer: any = null;
let draggie: Draggabilly;

export class WalletEntryPlugin {
    static WALLET_BTN_POSITION = 'walletBtnPosition';
    private auth: Auth;
    private walletEntryOptions: WalletEntryOptions;

    constructor(auth: Auth, options: WalletEntryOptions) {
        this.auth = auth;
        this.walletEntryOptions = options;

        if (typeof window !== 'undefined') {
            this.destroy();

            if (this.auth.isLogin()) {
                this.walletEntryRander();
            }

            this.auth.on('connect', () => {
                this.walletEntryRander();
            });

            this.auth.on('disconnect', () => {
                this.destroy();
            });
        }
    }

    private isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    public openWallet() {
        if (!this.auth?.isLogin?.()) {
            console.log('not login');
            this.auth?.login?.();
            return;
        }

        const url = walletUrl(this.auth);

        if (this.isMobile() || isBraveBrowser()) {
            window.open(url);
            return false;
        }
        const walletIcon: any = document.querySelector('.particle-pwe-wallet-icon');
        const downArrow = document.querySelector('.particle-pwe-down-arrow');
        const iframeContent: any = document.querySelector('.particle-pwe-iframe-content');
        if (!isNullish(this.auth?.getAuthTheme()?.modalBorderRadius)) {
            iframeContent.style.borderRadius = `${this.auth?.getAuthTheme()?.modalBorderRadius}px`;
        }
        iframeContent?.classList.add('particle-pwe-iframe-content-show');

        if (this.auth.getThemeType() == 'dark') {
            iframeContent?.classList.add('particle-pwe-iframe-content-dark');
            iframeContent?.classList.remove('particle-pwe-iframe-content-light');
        } else {
            iframeContent?.classList.add('particle-pwe-iframe-content-light');
            iframeContent?.classList.remove('particle-pwe-iframe-content-dark');
        }

        let iframe: HTMLIFrameElement | null = document.querySelector('.particle-pwe-iframe');

        if (
            iframe?.src &&
            qs.parse(iframe?.src.split('?').pop() as string).theme !== this.auth.getAuthTheme()?.uiMode
        ) {
            iframe.remove();
            iframe = null;
        }

        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.className = 'particle-pwe-iframe';
            iframe.allow = 'camera';
            iframeContent?.appendChild(iframe);
            iframe.src = url;
        }

        walletIcon?.classList.add('particle-pwe-wallet-icon-hide');
        downArrow?.classList.remove('particle-pwe-down-arrow-hide');
        this.updateIframeContentPosition();
    }

    public setWalletIcon() {
        const uiMode: UIMode = this.auth.getAuthTheme()?.uiMode || 'light';
        const walletIconEl: any = document.querySelector('.particle-pwe-wallet-icon');
        const downArrowEl: any = document.querySelector('.particle-pwe-down-arrow');

        if (uiMode === 'dark') {
            walletIconEl && walletIconEl.setAttribute('src', walletIconDarkBase64);
            downArrowEl && downArrowEl.setAttribute('src', downArrowDarkBase64);
        } else {
            walletIconEl && walletIconEl.setAttribute('src', walletIconBase64);
            downArrowEl && downArrowEl.setAttribute('src', downArrowBase64);
        }
    }

    public setTheme() {
        this.setWalletIcon();
    }

    private updateIframeContentPosition() {
        const iframeContent: any = document.querySelector('.particle-pwe-iframe-content');
        if (!iframeContent || iframeContent?.style?.display === 'none') {
            return;
        }
        const walletBtn: any = document.querySelector('.particle-pwe-btn');
        const walletBtnRect = walletBtn.getBoundingClientRect();
        const iframeContentRect = iframeContent.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const windowWidth = window.innerWidth;
        const iframeContentHeight = iframeContentRect.height;
        const iframeContentWidth = iframeContentRect.width;
        const walletBtnHeight = walletBtnRect.height;
        // const walletBtnWidth = walletBtnRect.width;
        const walletBtnTop = walletBtnRect.top;
        const walletBtnLeft = walletBtnRect.left;
        const walletBtnBottom = walletBtnRect.bottom;
        const walletBtnRight = walletBtnRect.right;

        if (
            walletBtnBottom + iframeContentHeight + 10 < windowHeight &&
            walletBtnRight + iframeContentWidth + 10 < windowWidth
        ) {
            iframeContent.style.top = walletBtnBottom + 10 + 'px';
            iframeContent.style.left = walletBtnLeft + 'px';
        } else if (
            walletBtnBottom + iframeContentHeight + 10 < windowHeight &&
            walletBtnLeft - iframeContentWidth - 10 > 0
        ) {
            iframeContent.style.top = walletBtnBottom + 10 + 'px';
            iframeContent.style.left = walletBtnRight - iframeContentWidth + 'px';
        } else if (
            walletBtnTop - iframeContentHeight - 10 > 0 &&
            walletBtnRight + iframeContentWidth + 10 < windowWidth
        ) {
            iframeContent.style.top = walletBtnTop - iframeContentHeight - 10 + 'px';
            iframeContent.style.left = walletBtnLeft + 'px';
        } else if (walletBtnTop - iframeContentHeight - 10 > 0 && walletBtnLeft - iframeContentWidth - 10 > 0) {
            iframeContent.style.top = walletBtnTop - iframeContentHeight - 10 + 'px';
            iframeContent.style.left = walletBtnRight - iframeContentWidth + 'px';
        } else if (walletBtnRight + iframeContentWidth + 10 < windowWidth) {
            const top = walletBtnTop + walletBtnHeight / 2 - iframeContentHeight / 2;
            iframeContent.style.top =
                top < 30
                    ? 30 + 'px'
                    : top > windowHeight - iframeContentHeight - 30
                    ? windowHeight - iframeContentHeight - 30 + 'px'
                    : top + 'px';
            iframeContent.style.left = walletBtnRight + 10 + 'px';
        } else if (walletBtnLeft - iframeContentWidth - 10 > 0) {
            const top = walletBtnTop + walletBtnHeight / 2 - iframeContentHeight / 2;
            iframeContent.style.top =
                top < 30
                    ? 30 + 'px'
                    : top > windowHeight - iframeContentHeight - 30
                    ? windowHeight - iframeContentHeight - 30 + 'px'
                    : top + 'px';
            iframeContent.style.left = walletBtnLeft - iframeContentWidth - 10 + 'px';
        } else {
            console.log('no space');
        }
    }

    private setButtonStorageData(data: any) {
        const { innerWidth, innerHeight } = window;
        const position = this.walletEntryOptions.position || WalletEntryPosition.BR;
        localStorage.setItem(
            WalletEntryPlugin.WALLET_BTN_POSITION,
            `${data.x},${data.y},${data.direction},${position}`
        );
        localStorage.setItem(WalletEntryPlugin.WALLET_BTN_POSITION + '_window', `${innerWidth},${innerHeight}`);
    }

    private getButtonStorageData() {
        const { innerWidth, innerHeight } = window;
        const [x, y, direction = 'right', position] =
            localStorage?.getItem(WalletEntryPlugin.WALLET_BTN_POSITION)?.split?.(',') || [];
        let [width, height]: any =
            localStorage.getItem(WalletEntryPlugin.WALLET_BTN_POSITION + '_window')?.split?.(',') || [];
        width = Number(width || 0);
        height = Number(height || 0);
        if (width && height && (width != innerWidth || height != innerHeight)) {
            localStorage.removeItem(WalletEntryPlugin.WALLET_BTN_POSITION);
            localStorage.removeItem(WalletEntryPlugin.WALLET_BTN_POSITION + '_window');
            return {
                x: innerWidth,
                y: innerHeight,
                position: position || this.walletEntryOptions.position || WalletEntryPosition.BR,
                direction: 'right',
            };
        }
        return {
            x: Number(x) || 0,
            y: Number(y) || 0,
            position: position || this.walletEntryOptions.position || WalletEntryPosition.BR,
            direction,
        };
    }

    private updateWalletBtnPosition(x: number, y: number, type = '') {
        const { width } = document.body.getBoundingClientRect();
        const { direction } = this.getButtonStorageData();
        const isRight = x > width / 2 || (type == 'windowResize' && direction === 'right');
        let left = isRight ? width - 60 : 0;
        let top = y;
        let newDirection = 'left';

        if (left < 30) {
            left = 30;
            newDirection = 'left';
        } else if (left > width - 90) {
            left = width - 90;
            newDirection = 'right';
        }
        if (top < 30) {
            top = 30;
        } else if (top > window.innerHeight - 90) {
            top = window.innerHeight - 90;
        }

        return {
            left,
            top,
            direction: newDirection,
        };
    }

    public closeWallet() {
        const iframeContent: HTMLDivElement | null = document.querySelector('.particle-pwe-iframe-content');
        iframeContent?.classList.remove('particle-pwe-iframe-content-show');
        const walletIcon: any = document.querySelector('.particle-pwe-wallet-icon');
        const downArrow = document.querySelector('.particle-pwe-down-arrow');
        walletIcon?.classList.remove('particle-pwe-wallet-icon-hide');
        downArrow?.classList.add('particle-pwe-down-arrow-hide');
    }

    private resize() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        return () => {
            clearTimeout(timer);

            timer = setTimeout(() => {
                localStorage.removeItem(WalletEntryPlugin.WALLET_BTN_POSITION);

                const walletBtn: HTMLDivElement | null = document.querySelector('.particle-pwe-btn');

                const { x: btnX, y: btnY } = this.getButtonStorageData();

                const x = btnX || window.innerWidth;
                const y = btnY || window.innerHeight;

                const { left, top, direction } = that.updateWalletBtnPosition(x, y, 'windowResize');
                if (walletBtn) {
                    walletBtn.style.left = left + 'px';
                    walletBtn.style.top = top + 'px';
                }

                this.setButtonStorageData({
                    x,
                    y,
                    direction,
                });

                that.updateIframeContentPosition();

                (async () => {
                    let count = 0;
                    do {
                        count++;
                        await this.sleep(100);
                        this.updateIframeContentPosition();
                    } while (count < 15);
                })();
            }, 10);
        };
    }

    private async sleep(ms: number) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    private preload() {
        try {
            console.log('Preload Web Wallet resource');
            const src = `${
                isParticleDev() ? 'https://wallet-debug.particle.network' : 'https://wallet.particle.network'
            }/preload/index.js?_=${+new Date()}`;
            const script = document.createElement('script');
            script.src = src;
            document.body.appendChild(script);
        } catch (error) {
            console.log(error);
        }
    }

    private async walletEntryRander() {
        styleRender();
        htmlRender();
        this.setWalletIcon();

        if (this.walletEntryOptions?.preload !== false) {
            this.preload();
        }

        const walletBtn: any = document.querySelector('.particle-pwe-btn');
        const maxZIndex = Math.max.apply(
            null,
            Array.from(document.querySelectorAll('*')).map((item) => {
                return Number(window.getComputedStyle(item).zIndex) || 0;
            })
        );

        walletBtn.style.zIndex = maxZIndex + 1;

        const { x: btnX, y: btnY } = this.getButtonStorageData();

        if (btnX && btnY) {
            if ((Number(btnX) || 0) < window.innerWidth && (Number(btnY) || 0) < window.innerHeight) {
                const { left, top } = this.updateWalletBtnPosition(Number(btnX) || 0, Number(btnY) || 0);
                walletBtn.style.left = left + 'px';
                walletBtn.style.top = top + 'px';
                this.updateIframeContentPosition();
            } else {
                const { left, top } = this.updateWalletBtnPosition(window.innerWidth, window.innerHeight);
                walletBtn.style.left = left + 'px';
                walletBtn.style.top = top + 'px';
                this.updateIframeContentPosition();
            }
        } else {
            // default wallet btn position
            const position = this.walletEntryOptions.position || WalletEntryPosition.BL;
            let top, left;
            if (position === WalletEntryPosition.BR) {
                top = window.innerHeight;
                left = window.innerWidth;
            } else if (position === WalletEntryPosition.TR) {
                top = 0;
                left = window.innerWidth;
            } else if (position === WalletEntryPosition.TL) {
                top = 0;
                left = 0;
            } else {
                top = window.innerHeight;
                left = 0;
            }

            const positionData = this.updateWalletBtnPosition(left, top);
            walletBtn.style.left = positionData.left + 'px';
            walletBtn.style.top = positionData.top + 'px';
            this.updateIframeContentPosition();
        }

        const walletIcon: any = document.querySelector('.particle-pwe-wallet-icon');
        const downArrow = document.querySelector('.particle-pwe-down-arrow');
        let isDraggie = false;

        // walletBtn 按下拖动位置到指定位置 draggabilly
        const Draggabilly = (await import('draggabilly')).default;
        draggie = new Draggabilly(walletBtn);

        draggie.on('dragStart', () => {
            isDraggie = true;
            walletBtn.style.cursor = 'move';
        });

        draggie.on('dragMove', () => {
            this.updateIframeContentPosition();
        });

        draggie.on('dragEnd', (event: any, pointer: any) => {
            event.stopPropagation();
            walletBtn.style.cursor = 'pointer';
            const { clientX: x, clientY: y } = pointer;
            const { left, top, direction } = this.updateWalletBtnPosition(x, y - 35);
            walletBtn.style.left = left + 'px';
            walletBtn.style.top = top + 'px';
            this.updateIframeContentPosition();

            (async () => {
                let count = 0;
                do {
                    count++;
                    await this.sleep(20);
                    this.updateIframeContentPosition();
                } while (count < 70);
            })();

            this.setButtonStorageData({
                x: left,
                y: top,
                direction,
            });

            setTimeout(() => {
                isDraggie = false;
            });
        });

        walletBtn.addEventListener('touchend', () => {
            if (!isDraggie) {
                this.openWallet();
            }
        });

        walletIcon?.addEventListener('click', (event: any) => {
            event?.stopPropagation?.();
            if (!isDraggie && !this.isMobile()) {
                this.openWallet();
            }
        });

        downArrow?.addEventListener('click', (e) => {
            e.stopPropagation();
            if (!isDraggie) {
                this.closeWallet();
            }
        });

        window.addEventListener('resize', this.resize(), false);
    }

    public destroy() {
        draggie?.destroy?.();
        window.removeEventListener('resize', this.resize(), false);
        document.querySelector('.particle-wallet-entry-container')?.remove?.();
    }
}
